export default function replaceSlugs(routePath: string, slugValues: { [key: string]: string }) {
    for (const [key, value] of Object.entries(slugValues)) {
        routePath = routePath.replace(`{${key}}`, value)
    }
    return routePath
}
